import { ProposalState } from "../../../types/types";

import {
  DOWNLOAD_ALLOCATION_FILE_FAILURE,
  DOWNLOAD_ALLOCATION_FILE_REQUEST,
  DOWNLOAD_ALLOCATION_FILE_SUCCESS,
  GET_ALLOCATION_HISTORY_FAILURE,
  GET_ALLOCATION_HISTORY_REQUEST,
  GET_ALLOCATION_HISTORY_SUCCESS,
  UPLOAD_PROPOSAL_FAILURE,
  UPLOAD_PROPOSAL_REQUEST,
  UPLOAD_PROPOSAL_SUCCESS,
} from "./actionTypes";

const proposalInitState: ProposalState = {
  allocationData: {
    loading: false,
    data: null,
  },
  allocationFile: {
    loading: false,
    data: null,
    done: false,
  },
  uploadProposal: {
    loading: false,
    done: false,
    data: null,
  }
};

export default (
  state = proposalInitState,
  action: { type: string; payload: any }
) => {
  switch (action.type) {
    case GET_ALLOCATION_HISTORY_REQUEST:
      return {
        ...state,
        allocationData: {
          loading: true,
          data: null,
        },
      };

    case GET_ALLOCATION_HISTORY_SUCCESS:
      return {
        ...state,
        allocationData: {
          loading: false,
          data: action.payload,
        },
      };

    case GET_ALLOCATION_HISTORY_FAILURE:
      return {
        ...state,
        allocationData: {
          loading: false,
          data: action.payload,
        },
      };

      case DOWNLOAD_ALLOCATION_FILE_REQUEST:
        return {
          ...state,
          allocationFile: {
            loading: true,
            done: false,
            data: null,
          },
        };
  
      case DOWNLOAD_ALLOCATION_FILE_SUCCESS:
        return {
          ...state,
          allocationFile: {
            loading: false,
            done: true,
            data: action.payload,
          },
        };
  
      case DOWNLOAD_ALLOCATION_FILE_FAILURE:
        return {
          ...state,
          allocationFile: {
            loading: false,
            done: false,
            data: action.payload,
          },
        };
  
      case UPLOAD_PROPOSAL_REQUEST:
        return {
          ...state,
          userUpload: {
            loading: true,
            done: false,
            data: action.payload,
          },
        };
  
      case UPLOAD_PROPOSAL_SUCCESS:
        return {
          ...state,
          userUpload: {
            loading: false,
            done: true,
            data: action.payload,
          },
        };
  
      case UPLOAD_PROPOSAL_FAILURE:
        return {
          ...state,
          userUpload: {
            loading: false,
            done: false,
            data: action.payload,
          },
        };
        
    default:
      return {
        ...state,
      };
  }
};
